import { createElement } from 'react';
import styled, { css } from 'styled-components';
import { variant, typography, color } from 'styled-system';
import PropTypes from 'prop-types';
import PropTypesStyled from '@styled-system/prop-types';

import variants, { keys } from './variants';

/* eslint-disable no-unused-vars */
const Text = styled(
  ({ component = 'span', variant: textVariant, mobileVariant, ...props }) =>
    createElement(component, { ...props })
)`
  color: ${({ theme }) => theme.colors.charcoal};
  ${variant({ variants })};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    ${p => css(variant({ variants })({ ...p, variant: p.mobileVariant }))}
  }
  ${typography};
  ${color};
  a {
    ${color};
    text-decoration: underline;
  }
`;

Text.propTypes = {
  ...PropTypesStyled.typography,
  ...PropTypesStyled.color,
  variant: PropTypes.oneOf(keys),
  mobileVariant: PropTypes.oneOf(keys),
};

export default Text;
